var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Base_Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.75512 19.2464H5.89687L17.0384 8.12569L15.8926 6.97969L4.75512 18.1089V19.2464ZM3.96763 20.8297C3.74262 20.8297 3.55371 20.7534 3.40088 20.6007C3.24821 20.4479 3.17188 20.2589 3.17188 20.0339V18.1199C3.17188 17.9098 3.21413 17.7052 3.29863 17.5062C3.38313 17.3072 3.49921 17.1345 3.64687 16.9882L17.0219 3.62569C17.1659 3.48752 17.3331 3.37869 17.5236 3.29919C17.7141 3.21952 17.9146 3.17969 18.1251 3.17969C18.3246 3.17969 18.5219 3.21927 18.7169 3.29844C18.9119 3.3776 19.0899 3.48944 19.2509 3.63394L20.3926 4.77969C20.5426 4.93252 20.6545 5.10544 20.7281 5.29844C20.8016 5.4916 20.8384 5.68485 20.8384 5.87819C20.8384 6.08752 20.8011 6.28894 20.7266 6.48244C20.652 6.67577 20.5406 6.84569 20.3926 6.99219L7.01337 20.3547C6.86771 20.5024 6.69579 20.6184 6.49763 20.7029C6.29946 20.7874 6.09362 20.8297 5.88012 20.8297H3.96763ZM16.4634 7.55469L15.8926 6.97969L17.0384 8.12569L16.4634 7.55469Z",
    fill: "#A1A1A1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.a154d82a7a53b39d1b22d11bae3e09d7.svg";
export { ForwardRef as ReactComponent };